export const EARN_REFERENCE_PREFIX = 'EARN_REF'
export const EARN_PRODUCT_PROVIDER_NAME = 'Coinbase'
export const EPC_TAKES_EARN_RETAINED_EARNINGS_PERCENTAGE = 100
